import React from "react";
import app from "../assets/app.svg";
import GooglePlay from "../assets/Google Play.svg";
import AndroidOS from "../assets/Android OS.svg";
import AppleInc from "../assets/Apple Inc.svg";
import iOSLogo from "../assets/iOS Logo.svg";
import LinkIcon from "../assets/Link.svg";
import asset3 from "../assets/asset3.png";

const MobileApp = ({ data }) => {
  let dataAllApplication = data?.data?.data?.application;

  const buttons = [
    { icon: GooglePlay, label: "Google Play" },
    { icon: AndroidOS, label: "Android" },
    { icon: AppleInc, label: "Apple Store" },
    { icon: iOSLogo, label: "iOS" },
    { icon: LinkIcon, label: "رابط مباشر" },
  ];

  return (
    <div dir="rtl" className="relative  flex flex-col-reverse md:flex-row items-center justify-between rounded-3xl md:px-20 p-10 w-[90%] bg-[#81B9DE] gap-5 mx-auto">
      <img
        src={asset3}
        alt="Decoration"
        className="hidden md:flex md:absolute w-40 z-20 top-10 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
      />
      {/* Right section: Text and buttons */}
      <div className="w-full md:w-1/2 flex flex-col items-start gap-6">
        <div className="text-white text-2xl font-semibold leading-relaxed bg-[#91c5e8] p-5 rounded-3xl">
          <p className="text-black">للحصول على المزيد من الميزات</p>
          <p>قم بتحميل التطبيق الآن</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 w-full">
          {buttons.map((btn, idx) => (
            <button
              key={idx}
              className={`flex items-center gap-2 px-4 py-2 rounded-xl shadow-md transition w-full
        ${idx === buttons.length - 1 ? 'bg-blue-900 text-white hover:bg-blue-800' : 'bg-white text-[#333] hover:bg-gray-100'}`}
            >
              <img src={btn.icon} alt={btn.label} className="w-5 h-5" />
              <span className="text-sm font-medium">{btn.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Left section: App image */}
      <div className="w-full md:w-1/2 flex justify-end">
        <img src={app} alt="Mobile App" className="max-w-xs w-full" />
      </div>
    </div>
  );
};

export default MobileApp;
